(() => {
  // Freshwater / Marine-Reef switch for tanks with a second kit (custom.aquarium_builder_kit_alt).
  // Loaded only when the section sets data-alt-kits-url. The kit level carries over when switching.
  const Kit = customElements.get('aquarium-builder-kit');
  if (!Kit || Kit.prototype.mountWater) return;

  const STYLE = `
.abk .abk-water{display:flex;flex-wrap:wrap;align-items:center;gap:8px 12px;margin-top:4px}
.abk .abk-water__label{font-size:14px;font-weight:600;color:#3f464c}
.abk .abk-water__seg{display:inline-flex;gap:4px;padding:4px;border-radius:999px;background:#fff;border:1px solid var(--abk-line,#e6e8ea)}
.abk .abk-water__btn{min-height:38px;padding:0 18px;border:0;border-radius:999px;background:none;font-size:14px;font-weight:600;color:#3f464c}
.abk .abk-water__btn.is-on{background:var(--abk-navy,#021429);color:#fff}
.abk[aria-busy="true"] .abk__tiers,.abk[aria-busy="true"] .abk__layout,.abk[aria-busy="true"] [data-mobile]{opacity:.5;pointer-events:none}`;
  const LABEL = {fresh: 'Freshwater', reef: 'Marine / Reef'};
  const waterOf = kit => (/reef|marine/i.test(kit?.heading || '') ? 'reef' : 'fresh');
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));

  function addStyle() {
    if (document.getElementById('abk-water-style')) return;
    const st = document.createElement('style');
    st.id = 'abk-water-style';
    st.textContent = STYLE;
    document.head.appendChild(st);
  }

  Kit.prototype.mountWater = async function () {
    if (this.waterMounted || !this.dataset.altKitsUrl || !this.kit) return;
    this.waterMounted = true;
    try {
      const alt = await (await fetch(this.dataset.altKitsUrl, {headers: {Accept: 'application/json'}})).json();
      const altKit = alt.kits?.[this.dataset.handle];
      if (!altKit || waterOf(altKit) === waterOf(this.kit)) return;
      this.waterSources = {[waterOf(this.kit)]: {data: this.data, kit: this.kit}, [waterOf(altKit)]: {data: alt, kit: altKit}};
      this.water = waterOf(this.kit);
      addStyle();
      const bar = document.createElement('div');
      bar.className = 'abk-water';
      bar.innerHTML = `<span class="abk-water__label">Setting up for</span><span class="abk-water__seg" role="radiogroup" aria-label="Water type">${['fresh', 'reef'].map(w => `<button type="button" role="radio" class="abk-water__btn" data-water="${w}">${esc(LABEL[w])}</button>`).join('')}</span>`;
      bar.addEventListener('click', event => {
        const btn = event.target.closest('[data-water]');
        if (btn) this.setWater(btn.dataset.water);
      });
      this.querySelector('.abk__head')?.appendChild(bar);
      this.paintWater();
    } catch (error) { /* the main kit still works without the switch */ }
  };

  Kit.prototype.paintWater = function () {
    this.querySelectorAll('[data-water]').forEach(btn => {
      const on = btn.dataset.water === this.water;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-checked', String(on));
    });
  };

  Kit.prototype.setWater = async function (water) {
    const source = this.waterSources?.[water];
    if (!source || water === this.water || this.getAttribute('aria-busy') === 'true') return;
    this.setAttribute('aria-busy', 'true');
    try {
      const root = this.dataset.rootUrl.replace(/\/$/, '');
      const handles = [...new Set(source.kit.slots.flatMap(slot => Object.values(slot.picks).flatMap(pick => pick.items.map(item => item.handle))))].filter(handle => !(handle in this.products));
      const products = await Promise.all(handles.map(handle => fetch(`${root}/products/${handle}.js`).then(r => (r.ok ? r.json() : null)).catch(() => null)));
      handles.forEach((handle, i) => { this.products[handle] = products[i]; });
      this.water = water;
      this.data = source.data;
      this.kit = source.kit;
      this.overrides = {};
      this.removed = new Set();
      this.step = null;
      this.paintWater();
      this.render();
    } finally {
      this.removeAttribute('aria-busy');
    }
  };

  const render = Kit.prototype.render;
  Kit.prototype.render = function (...args) {
    const out = render.apply(this, args);
    if (!this.waterMounted) this.mountWater();
    return out;
  };

  // A kit that rendered before this script loaded still gets its switch.
  document.querySelectorAll('aquarium-builder-kit').forEach(el => { if (el.kit && !el.hidden) el.mountWater(); });
})();
